import { Typography, Box } from '@mui/material';

import SectionTitle from '../../Survey/components/SectionTitle';

const contents = [
  'mcg/kg/min , mg/kg/min = Rate X Weight X 60 X Total amount(cc) / Drug dosage(mcg or mg)',
  'mcg/kg/hr , mg/kg/hr = Rate X Weight X Total amount(cc) / Drug dosage(mcg or mg)',
  'mg/hr = Rate X Total amount(cc) / Drug dosage(mg)',
  'mg/min, u/min = Rate X 60 X Total amount(cc) / Drug dosage(mg or u)',
  'gtt = Injection volume per hour(ml/hr) / 3 ',
  'ml/hr = Drops per minute(gtt) X 3',
];

const CautionList = () => {
  return (
    <>
      <SectionTitle title="Các công thức tính liều lượng thuốc" />
      <Box sx={{ width: '98%', margin: '48px auto 0px 25px' }}>
        {contents.map((v, i) => (
          <Typography
            sx={{
              fontWeight: '400',
              fontSize: '14px',
              lineHeight: '38px',
              whiteSpace: 'pre',
            }}
          >
            ・ {v}
          </Typography>
        ))}
      </Box>
    </>
  );
};

export default CautionList;
